export default "__VITE_ASSET__a0caf902__"